module.exports = __webpack_public_path__ + "img/tcApi_result_success.1e832b2e.png";